import { make } from "vuex-pathify";
import { i18n } from "@/plugins/i18n.js"
import { wdConfigData } from "@/service/wd_app_config.js";

const state = {
  lengthMenus: [
    {
      id: "optimize_menu_length",
      // title: "精炼的",
      title: 'Brief',
      value: "短的",
      hasSubMenus: false,
      subMenus: [],
    },
    {
      id: "optimize_menu_length",
      // title: "正常的",
      title: 'Standard',
      value: "中等",
      hasSubMenus: false,
      subMenus: [],
    },
    {
      id: "optimize_menu_length",
      // title: "丰富的",
      title: 'Extended',
      value: "长的",
      hasSubMenus: false,
      subMenus: [],
    }
  ],
  toneMenus: [
    {
      id: "optimize_menu_style",
      // title: "专业的",
      title: 'Expert',
      value: "专业的",
      hasSubMenus: false,
      subMenus: [],
    },
    {
      id: "optimize_menu_style",
      // title: "正常的",
      title: 'Normal',
      value: "中立的",
      hasSubMenus: false,
      subMenus: [],
    },
    {
      id: "optimize_menu_style",
      // title: "随意的",
      title: 'Casual',
      value: "非正式的",
      hasSubMenus: false,
      subMenus: [],
    }
  ],
  aiMenus: [
    {
      id: "taskType_semantic_whole_template_ppt",
      title: i18n.t("ppt_menus.ppt_menus_full_template_ppt"),
      hasSubMenus: false
    },
    {
      id: "task_all_normal",
      // title: "生成完整PPT",
      title: 'Full Slides',
      hasSubMenus: false
    },
    {
      id: "taskType_outline",
      // title: "生成PPT大纲",
      title: 'Outline',
      hasSubMenus: false,
    },
    {
      id: "task_one_page_general",
      // title: "生成单页PPT",
      title: 'Single Silde',
      hasSubMenus: false,
    },
    {
      id: "taskType_Ppt_OnePage",
      // title: "咨询画布",
      title: 'Consulting Canvas',
      hasSubMenus: true,
      subMenus: [
        {
          id: "task_one_page_classic_canvas",
          // title: "商业模式画布",
          title: 'Business Model',
          template_id: "template_one_page_classic_canvas",
        },
        {
          id: "task_one_page_market_size",
          // title: "市场规模分析",
          title: 'TAM',
          template_id: "template_one_page_market_size",
        },
        {
          id: "task_one_page_market_adoption",
          // title: "跨越鸿沟理论",
          title: 'Cross the Chasm',
          template_id: "template_one_page_market_adoption",
        },
      ],
    },
    {
      id: "task_ppt_translate_all",
      title: 'Translate All',
      hasSubMenus: true,
      subMenus: [
        {
          id: "task_ppt_translate_all_en",
          // title: "英文",
          title: 'to English',
        },
        {
          id: "task_ppt_translate_all_zh",
          // title: "中文",
          title: 'to Chinese',
        },
      ],
    },
    {
      id: "task_operation_general",
      // title: i18n.t("ppt_menus.ppt_menus_ppt_uniform_style"),
      title: 'Unify Visual',
      hasSubMenus: true,
      subMenus: [
        {
          id: "task_operation_font_type",
          // title: i18n.t("ppt_menus.ppt_menus_ppt_uniform_style_font"),
          title: 'Font',
        },
        {
          id: "task_operation_shape_color",
          // title: i18n.t("ppt_menus.ppt_menus_ppt_uniform_style_color"),
          title: 'Theme Color',
        },
      ],
    },
    {
      id: "taskType_outline_optimize",
      // title: "优化大纲",
      title: 'Refine Outline',
      hasSubMenus: false,
    },
    {
      id: "taskType_outline_ppt",
      // title: "大纲生成PPT",
      title: 'Outline to Slides',
      hasSubMenus: false,
    },
    // index = 5
    {
      id: "taskType_ppt_from_file",
      // title: "从文件创建PPT",
      title: 'File to Slides',
      hasSubMenus: false,
    },
  ],
  actionTypes: [
    {
      id: "taskType_create_title",
      title: 'Suggest Title',
      hasSubMenus: false,
    },
    {
      id: "taskType_integrate_text",
      title: 'Merge Text',
      hasSubMenus: false
    },
    {
      id: "task_rewrite_text",
      title: 'Rephrase',
      hasSubMenus: false,
    },
    {
      id: "task_generate_image",
      title: 'Add Image',
      hasSubMenus: false,
    },
    {
      id: "task_generate_image",
      title: 'More Image',
      hasSubMenus: false,
    },
    {
      id: "taskType_ppt_translation",
      title: 'Trans to Eng',
      hasSubMenus: false,
    },
    {
      id: "task_generate_image_replace",
      title: 'Smart Img Replace',
      hasSubMenus: false,
    },
    {
      id: "task_enrich_one_page_content",
      title: 'Enrich',
      hasSubMenus: false,
    },
    {
      id: "taskType_one_page_content_from_title",
      title: 'Auto Content',
      hasSubMenus: false,
    },
  ],
  pptOptionMenus: [
    {
      id: "ppt_option_menu_textonly",
      title: "纯文字",
    },
    {
      id: "ppt_option_menu_text_oneimage",
      title: "文+封面图",
    },
    {
      id: "ppt_option_menu_text_allimages",
      title: "文+每页图",
    },
  ],
  font_types: [
    {id: '0001', fileName: '宋体', value: '宋体', cover: require("@/assets/fontcover/0001.png")},
    {id: '0002', fileName: '等线', value: '等线', cover: require("@/assets/fontcover/0002.png")},
    {id: '0003', fileName: '华文宋体', value: '华文宋体', cover: require("@/assets/fontcover/0003.png")},
    {id: '0005', fileName: 'Microsoft YaHei', value: '微软雅黑', cover: require("@/assets/fontcover/0004.png")}
  ],
  shape_colors: [
    {id: '0001', fileName: 'Light Gray', value: '#DBDCDE', cover: require("@/assets/shapecolorcover/0001.png")},
    {id: '0002', fileName: 'Teal Blue', value: '#00A0A3', cover: require("@/assets/shapecolorcover/0002.png")},
    {id: '0003', fileName: 'Deep Sea Blue', value: '#012169', cover: require("@/assets/shapecolorcover/0003.png")},
    {id: '0004', fileName: 'Dark Green', value: '#2C5234', cover: require("@/assets/shapecolorcover/0004.png")},
    {id: '0005', fileName: 'Bright Blue', value: '#00A3E0', cover: require("@/assets/shapecolorcover/0005.png")}
  ],
  
  ImageStyle: [
    {
      Mode:'business',
      styles: [
        { text: "Photorealism", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Photorealism.png"), value:"Photorealism" },
        { text: "Documentary Photography", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Contemporary-Documentary-Photography.png"), value:"Contemporary Documentary Photography" },
        { text: "Illustration", icon: 'mdi-billboard', selected: false, imgPath:  require("@/views/chatdoc/img/business-illustration.png"), value:"illustration" },
        { text: "minimalism", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/business-Minimalism.png"), value:"Minimalism" },
        { text: "realism", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/business-realism.png"), value:"realism" },
      ]
    },
    {
      Mode:'free',
      styles: [
        { text: "Surreal", icon: 'mdi-camera', selected: false, imgPath:  require("@/views/chatdoc/img/Surreal.png"), value:"Surreal" },
        { text: "Cyberpunk", icon: 'mdi-robot-mower', selected: false, imgPath:  require("@/views/chatdoc/img/Cyberpunk.png"), value:"Cyberpunk" },
        { text: "Oil painting", icon: 'mdi-panorama-variant', selected: false, imgPath:  require("@/views/chatdoc/img/Oil.png"), value:"Oil painting" },
        { text: "Ink painting", icon: 'mdi-image-filter-hdr', selected: false, imgPath:  require("@/views/chatdoc/img/Ink.png"), value:"Ink painting" },
        { text: "Illustration", icon: 'mdi-billboard', selected: false, imgPath:  require("@/views/chatdoc/img/illustration.png"), value:"illustration" },
        { text: "Stickers", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Stickers.png"), value:"Stickers" },
        { text: "Impressionism", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Impressionism.png"), value:"Impressionism" },
        { text: "Post-Impressionism", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Post-Impressionism.png"), value:"Post Impressionism" },
        { text: "Symbolism", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Symbolism.png"), value:"Symbolism" },
        { text: "Pop art", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Pop-art.png"), value:"Pop art" },
        { text: "minimalism", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/minimalism.png"), value:"Minimalism" },
        { text: "Conceptual art", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Conceptual-art.png"), value:"Conceptual art" },
        { text: "Contemporary art", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Contemporary-art.png"), value:"Contemporary art" },
        { text: "Baroque", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Baroque.png"), value:"Baroque" },
        { text: "Rococo", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Rococo.png"), value:"Rococo" },
        { text: "Neoclassicism", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Neoclassicism.png"), value:"Neoclassicism" },
        { text: "Romanticism", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Romanticism.png"), value:"Romanticism" },
        { text: "realism", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/realism.png"), value:"realism" },
        { text: "Expressionism", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Expressionism.png"), value:"Expressionism" },
        { text: "Cubism", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Cubism.png"), value:"Cubism" },
        { text: "Surrealism", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Surrealism.png"), value:"Surrealism" },
        { text: "Abstract Expressionism", icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Abstract-Expressionism.png"), value:"Abstract Expressionism" },
      ]
    }
  ],
  // ImageStyle: [
  //   {
  //     Mode:'business',
  //     styles: [
  //       { text: i18n.t("ppt_img_style.img_style_photorealism"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Photorealism.png"), value:"Photorealism" },
  //       { text: i18n.t("ppt_img_style.img_style_contemporary_documentary_photography"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Contemporary-Documentary-Photography.png"), value:"Contemporary Documentary Photography" },
  //       { text: i18n.t("ppt_img_style.img_style_illustration"), icon: 'mdi-billboard', selected: false, imgPath:  require("@/views/chatdoc/img/business-illustration.png"), value:"illustration" },
  //       { text: i18n.t("ppt_img_style.img_style_minimalism"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/business-Minimalism.png"), value:"Minimalism" },
  //       { text: i18n.t("ppt_img_style.img_style_realism"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/business-realism.png"), value:"realism" },
  //     ]
  //   },
  //   {
  //     Mode:'free',
  //     styles: [
  //       { text: i18n.t("ppt_img_style.img_style_surreal"), icon: 'mdi-camera', selected: false, imgPath:  require("@/views/chatdoc/img/Surreal.png"), value:"Surreal" },
  //       { text: i18n.t("ppt_img_style.img_style_cyberpunk"), icon: 'mdi-robot-mower', selected: false, imgPath:  require("@/views/chatdoc/img/Cyberpunk.png"), value:"Cyberpunk" },
  //       { text: i18n.t("ppt_img_style.img_style_oil"), icon: 'mdi-panorama-variant', selected: false, imgPath:  require("@/views/chatdoc/img/Oil.png"), value:"Oil painting" },
  //       { text: i18n.t("ppt_img_style.img_style_ink"), icon: 'mdi-image-filter-hdr', selected: false, imgPath:  require("@/views/chatdoc/img/Ink.png"), value:"Ink painting" },
  //       { text: i18n.t("ppt_img_style.img_style_illustration"), icon: 'mdi-billboard', selected: false, imgPath:  require("@/views/chatdoc/img/illustration.png"), value:"illustration" },
  //       { text: i18n.t("ppt_img_style.img_style_stickers"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Stickers.png"), value:"Stickers" },
  //       { text: i18n.t("ppt_img_style.img_style_impressionism"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Impressionism.png"), value:"Impressionism" },
  //       { text: i18n.t("ppt_img_style.img_style_post_impressionism"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Post-Impressionism.png"), value:"Post Impressionism" },
  //       { text: i18n.t("ppt_img_style.img_style_symbolism"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Symbolism.png"), value:"Symbolism" },
  //       { text: i18n.t("ppt_img_style.img_style_pop_art"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Pop-art.png"), value:"Pop art" },
  //       { text: i18n.t("ppt_img_style.img_style_minimalism"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/minimalism.png"), value:"Minimalism" },
  //       { text: i18n.t("ppt_img_style.img_style_conceptual_art"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Conceptual-art.png"), value:"Conceptual art" },
  //       { text: i18n.t("ppt_img_style.img_style_contemporary_art"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Contemporary-art.png"), value:"Contemporary art" },
  //       { text: i18n.t("ppt_img_style.img_style_baroque"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Baroque.png"), value:"Baroque" },
  //       { text: i18n.t("ppt_img_style.img_style_rococo"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Rococo.png"), value:"Rococo" },
  //       { text: i18n.t("ppt_img_style.img_style_neoclassicism"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Neoclassicism.png"), value:"Neoclassicism" },
  //       { text: i18n.t("ppt_img_style.img_style_romanticism"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Romanticism.png"), value:"Romanticism" },
  //       { text: i18n.t("ppt_img_style.img_style_realism"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/realism.png"), value:"realism" },
  //       { text: i18n.t("ppt_img_style.img_style_expressionism"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Expressionism.png"), value:"Expressionism" },
  //       { text: i18n.t("ppt_img_style.img_style_cubism"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Cubism.png"), value:"Cubism" },
  //       { text: i18n.t("ppt_img_style.img_style_surrealism"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Surrealism.png"), value:"Surrealism" },
  //       { text: i18n.t("ppt_img_style.img_style_abstract_expressionism"), icon: 'mdi-sticker-emoji', selected: false, imgPath:  require("@/views/chatdoc/img/Abstract-Expressionism.png"), value:"Abstract Expressionism" },
  //     ]
  //   }
  // ],

  ImageMode: [
    {
      id: 'business',
      title: i18n.t("ppt_img_mode.img_mode_business"),
    },
    {
      id: 'free',
      title: i18n.t("ppt_img_mode.img_mode_free"),
    }
  ],
};

const mutations = make.mutations(state);

const getters = make.getters(state);

const actions = make.actions(state);

function resetState() {
  i18n.locale = wdConfigData.localLanguage
 }

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,

  resetState,
};
